import { Slice } from 'prosemirror-model';

export function isMarkdown(text: string): boolean {
  // code-ish
  const fences = text.match(/^```/gm);
  if (fences && fences.length > 1) {
    return true;
  }

  // link-ish
  if (text.match(/\[[^]+\]\(https?:\/\/\S+\)/gm)) {
    return true;
  }
  if (text.match(/\[[^]+\]\(\/\S+\)/gm)) {
    return true;
  }

  // heading-ish
  if (text.match(/^#{1,6}\s+\S+/gm)) {
    return true;
  }

  // list-ish
  const listItems = text.match(/^([-*]|\d+.)\s\S+/gm);
  if (listItems && listItems.length > 1) {
    return true;
  }

  return false;
}

export function sliceSingleNode(slice: Slice) {
  return slice.openStart === 0 && slice.openEnd === 0 && slice.content.childCount === 1
    ? slice.content.firstChild
    : null;
}
